module.exports = __webpack_public_path__ + "img/team-5.edc7106b.jpg";